import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LineOfBusinessReference, PlatformService } from '@core/service/platform.service';
import { LineOfBusiness } from '../index';

type LineOfBusinessMap = Record<LineOfBusiness, LineOfBusinessReference>;

export const LineOfBusinessResolver: ResolveFn<LineOfBusinessMap> = () => inject(PlatformService).getLineOfBusinesses();
